import React from 'react';
import './Input.css';

const Input = ({ 
  type = 'text', 
  label, 
  value, 
  onChange, 
  placeholder, 
  error, 
  helperText,
  disabled = false,
  required = false,
  icon,
  ...props 
}) => {
  return (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      {label && (
        <label className="form-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <div className="input-wrapper">
        {icon && <i className={`input-icon ${icon}`}></i>}
        <input
          type={type}
          className={`form-input ${icon ? 'with-icon' : ''} ${error ? 'error' : ''}`}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          {...props}
        />
      </div>
      {error && <div className="error-text">{error}</div>}
      {helperText && !error && <div className="helper-text">{helperText}</div>}
    </div>
  );
};

export default Input;